// extracted by mini-css-extract-plugin
module.exports = {"container":"Register_container__2XBmF","img":"Register_img__Fq9iA"};